import { render, staticRenderFns } from "./commonNoticeTip.vue?vue&type=template&id=2ba12fe0&scoped=true"
import script from "./commonNoticeTip.vue?vue&type=script&lang=js"
export * from "./commonNoticeTip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba12fe0",
  null
  
)

export default component.exports